import QueryEmployeeTransactions from "graphql/queries/QueryEmployeeTransactions";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchTransactions = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employee_transactions', QueryEmployeeTransactions, {
			resultPath: [ 'employee_me', 'transactions' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchTransactions
